import { Col, Image, Row } from "react-bootstrap"
import successlogo from '../../assets/images/successtick.gif'

const EnquirySuccessScreen = () => {
    return (
        <>
            <Row>
                <Col lg={12} className="d-flex justify-content-center align-items-center">
                    <Image src={successlogo} height={100} width={110} />
                </Col>
            </Row>
            <Row>
                <Col lg={12} className="d-flex  justify-content-center align-items-center mt-5">
                    <text className="text-center" style={{ fontSize: '16px' }}>
                        We've received your enquiry and will get back to you shortly.
                    </text>
                </Col>
            </Row>
        </>
    )
}

export default EnquirySuccessScreen;